module.exports = __webpack_public_path__ + "img/image12.539a85eb.png";